import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Text } from "@mantine/core";

import {
  AuthFormContainer,
  type CommonAuthFormProps,
} from "@/components/auth-form-container";
import { PhoneInput } from "@/components/phone-input";

interface AddPhoneFormProps extends CommonAuthFormProps {
  onChange: (phone: string) => void;
  phoneNumber: string;
}

export const AddPhoneForm = ({
  errorMessage,
  onChange,
  onSubmit,
  phoneNumber,
}: AddPhoneFormProps) => {
  return (
    <AuthFormContainer
      bottomContent={
        <Text c="gray.7" ta="center">
          Your organization requires a phone number for two-factor
          authentication.
        </Text>
      }
      errorMessage={errorMessage}
      onSubmit={onSubmit}
      submitButtonContent="Add phone number"
      submitButtonProps={{
        className:
          "disabled:bg-uw-green disabled:opacity-50 disabled:text-white",
        disabled: !phoneNumber || phoneNumber.length !== 10,
        rightSection: <FontAwesomeIcon icon={faPlus} />,
      }}
      subTitle="We’ll use this number to set up two-factor authentication for your account."
      title="Add phone number"
    >
      <PhoneInput autoFocus onChange={onChange} />
    </AuthFormContainer>
  );
};
